// Shared style helpers for Modal UI v2 — keep the app header/sub-header
// visible and interactive above a modal's own overlay (matches the
// Customer Management modal pattern). Used by modals with their own custom
// fixed-position overlay (not the shared <Dialog> primitive, which has its
// own `topOffset` prop for the same purpose — see components/ui/dialog.jsx).
//
// Zoom-proof: `headerHeight` (from ActivityBarContext) is where the sub-header
// ends, measured in the page's OWN CSS pixels, and `--c30-vh` is the viewport
// height in those same pixels (both kept up to date by AppHeader — see
// utils/modalViewport.js). Together they stay correct when the page is zoomed
// (utils/desktopZoomFix.js), which a raw `100vh` does not. Without the header
// (variable not set) it falls back to plain 100vh, exactly as before.
export const MODAL_V2_VIEWPORT_HEIGHT = 'var(--c30-vh, 100vh)';

export const modalV2OverlayStyle = (modalUiV2, headerHeight) =>
  (modalUiV2 ? { top: headerHeight, zIndex: 45 } : {});

export const modalV2OverlayClass = (modalUiV2) =>
  (modalUiV2 ? 'bg-black/50' : 'bg-black/70 backdrop-blur-sm');

export const modalV2ContentMaxHeight = (modalUiV2, headerHeight, margin = 24) =>
  (modalUiV2 ? { maxHeight: `calc(${MODAL_V2_VIEWPORT_HEIGHT} - ${headerHeight}px - ${margin}px)` } : {});
